import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import SendPdfWithPaymentMethods from "../../../presentation/modules/inbox/PaymentLinks/SendPdfWithPaymentMethods";
import { sharingInformationService } from "../../../services/sharingInformationService";

const RxJOrderPdfModal = ({ className }) => {
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [originData, setOriginData] = useState({});
  const selectedId = useSelector((state) => state.conversationsReducer.selectedConversationId);
  const lastSelectedIdRef = useRef(selectedId);

  useEffect(() => {
    const subscription$ = sharingInformationService.getSubject();

    const myObservable = subscription$.subscribe((data) => {
      if ('openPdfPaymentLinks' in data) {
        setShowPdfModal(data.openPdfPaymentLinks);
        setOriginData(data.payload || {});
      }
      // Cerrar PDF modal cuando se abre payment links
      if ('closePdfModal' in data && data.closePdfModal) {
        setShowPdfModal(false);
        setOriginData({});
      }
    });

    return () => {
      myObservable.unsubscribe();
    };
  }, []);

  // Cerrar el modal si cambia la conversación seleccionada mientras está abierto
  useEffect(() => {
    if (!showPdfModal) {
      lastSelectedIdRef.current = selectedId;
      return;
    }

    if (lastSelectedIdRef.current == null) {
      lastSelectedIdRef.current = selectedId;
      return;
    }

    if (selectedId !== lastSelectedIdRef.current) {
      setShowPdfModal(false);
      setOriginData({});
    }
  }, [selectedId, showPdfModal]);

  useEffect(() => {
    sharingInformationService.setSubject({ showPdfModal });
    sharingInformationService.setSubject({});
    // Cerrar payment links cuando se abre el PDF modal
    if (showPdfModal) {
      sharingInformationService.setSubject({
        closePaymentLinksForPdf: true,
        closeProductSelection: true,
        closeFastAnswersSelection: true
      });
      sharingInformationService.setSubject({});
    }
  }, [showPdfModal]);

  const onClose = () => {
    setShowPdfModal(false);
    setOriginData({});
  };

  const onSendPdf = (selectedPaymentMethods, formattedDateTime) => {
    // Enviar evento para que el componente que abrió el modal ejecute generateOrderPdf
    sharingInformationService.setSubject({
      sendPdfWithPaymentMethods: true,
      payload: {
        order: originData.order,
        platform: originData.platform,
        selectedPaymentMethods,
        formattedDateTime
      }
    });
    sharingInformationService.setSubject({});
    setShowPdfModal(false);
    setOriginData({});
  };

  // No renderizar si showPdfModal es false
  if (!showPdfModal) {
    return null;
  }

  // No renderizar si no hay order (pero solo si showPdfModal es true)
  if (!originData.order) {
    return null;
  }

  return (
    <SendPdfWithPaymentMethods
      key={`pdf-modal-${showPdfModal}-${originData.order?.web_id || originData.order?.id || 'no-order'}`}
      order={originData.order}
      onClose={onClose}
      onSendPdf={onSendPdf}
      className={className}
    />
  );
};

export default RxJOrderPdfModal;
